const comment = {
	attrs: { count: { default: null }, comment: { default: null }, answers: { default: null } },
	inclusive: false,
};

export default comment;
